import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="viewer-container">
      <div className="legal-page">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Easy Coding Tools ("we," "our," or "us"). We are committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you 
            visit our website www.easycodingtools.com.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Information You Provide</h3>
          <p>We may collect information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Use our JSON, XML, or file conversion tools</li>
            <li>Contact us through our contact form</li>
            <li>Subscribe to our newsletter or updates</li>
          </ul>

          <h3>2.2 Automatically Collected Information</h3>
          <p>We may automatically collect certain information about your device and usage patterns, including:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Pages visited and time spent on pages</li>
            <li>Referring website addresses</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process your file conversions and tool usage</li>
            <li>Respond to your inquiries and support requests</li>
            <li>Send you technical notices and updates</li>
            <li>Monitor and analyze usage patterns</li>
            <li>Detect, prevent, and address technical issues</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Processing and Storage</h2>
          <p>
            <strong>Important:</strong> All file conversions and data processing are performed in real-time. 
            We do not store your files, JSON/XML data, or conversion results on our servers. All processing is 
            done in memory and files are immediately discarded after conversion.
          </p>
        </section>

        <section>
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our website and hold certain 
            information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>We may use third-party services that collect information used to identify you, including:</p>
          <ul>
            <li><strong>Google AdSense:</strong> For displaying advertisements. Google's use of advertising cookies 
            enables it and its partners to serve ads based on your visit to our site.</li>
            <li><strong>Analytics Services:</strong> To understand how visitors use our website.</li>
          </ul>
        </section>

        <section>
          <h2>7. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your information. 
            However, no method of transmission over the Internet or electronic storage is 100% secure.
          </p>
        </section>

        <section>
          <h2>8. Your Rights</h2>
          <p>Depending on your location, you may have the following rights regarding your personal information:</p>
          <ul>
            <li>Right to access your personal data</li>
            <li>Right to rectification of inaccurate data</li>
            <li>Right to erasure ("right to be forgotten")</li>
            <li>Right to restrict processing</li>
            <li>Right to data portability</li>
            <li>Right to object to processing</li>
          </ul>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Our services are not intended for children under 13 years of age. We do not knowingly collect personal 
            information from children under 13.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the 
            new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> privacy@easycodingtools.com<br />
            <strong>Website:</strong> www.easycodingtools.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

